/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import poutine from '../../../img/cards/poutine.png';

import styles from '../../../styles/cards/lorem.module.scss';

const propTypes = {
    theme: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    theme: null,
    className: null,
};

// eslint-disable-next-line no-unused-vars
const CustomPoutineCard = ({ theme, className }) => (
    <div
        className={classNames([
            styles.container,
            styles[theme],
            {
                [className]: className !== null,
            },
        ])}
    >
        <div className={styles.inner}>
            <div className={styles.top}>
                <img className={styles.poutine} size="small" src={poutine} alt="Poutine" />
            </div>
            <div className={styles.bottom}>Lorem...</div>
        </div>
    </div>
);
CustomPoutineCard.propTypes = propTypes;
CustomPoutineCard.defaultProps = defaultProps;

export default CustomPoutineCard;
